// helpers are global common classes

import breakpointsFunc from './breakpointsFunc';
const helpers = {
  flexGrow: {
    flexGrow: '1'
  },
  noWrap: {
    whiteSpace: 'nowrap'
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  actionsBar: {
    display: 'flex',
    alignItems: 'center'
  },
  actionsBarButton: {
    '& + &': {
      marginLeft: '10px'
    }
  },
  siblingText: {
    marginLeft: '20px',
    textTransform: 'capitalize'
  },
  modalAlert: {
    margin: '-40px -40px 0 -40px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      margin: '-40px -24px 0 -24px'
    }
  },
  hideMobile: {
    [breakpointsFunc.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  showMobile: {
    display: 'none',
    [breakpointsFunc.breakpoints.down('sm')]: {
      display: 'block'
    }
  },
  leftSpace: {
    marginLeft: '4px'
  },
  plainList: {
    margin: '0',
    paddingLeft: '22px'
  },
  wip: {
    border: "1px solid #ff00007a",
    borderRadius: '2px'
  },
  overflowCellWrapper: {
    width: '100%'
  },
  overflowCell: {
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
};
export default helpers;